import { useEffect, useState } from "react";

import { api } from "../../services/axios";

export const useGetTickets = (document) => {
  const [tickets, setTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(true);
  const [ticketsError, setTicketsError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setTicketsLoading(true);
        setTicketsError(null);
        const { data } = await api.get("/effort/consultar_os_Effort", {
          params: { document },
        });

        if (data?.result?.length === 0) {
          setTicketsError(null);
          setTickets([]);
          return;
        }

        setTickets(data);
      } catch (error) {
        setTicketsError(error?.response?.message || "Erro ao buscar tickets");
        setTickets([]);
      } finally {
        setTicketsLoading(false);
      }
    };
    fetchData();
  }, [document]);

  return { tickets, ticketsLoading, ticketsError };
};
